module.exports = __webpack_public_path__ + "img/Share.6c741956.svg";